<template>
  <div class="bg-white shadow-sm sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        {{ product.title }}
      </h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-500">{{ $t("by") }} {{ product.vendor }}</p>
      <img :src="product.imageUrl" :alt="product.title" class="h-1/4 w-1/4" />
    </div>
    <div class="px-5 py-5 space-y-2">
      <FieldRow :label="$t('Name')" :value="product.title" />
      <FieldRow label="Reference" :value="product.referenceId" />
      <FieldRow :label="$t('Product Type')" :value="$t(`${product.productType}`)" />
      <FieldRow :label="$t('Vendor')" :value="product.vendor" />
      <FieldRow :label="$t('Status')">
        <FieldSpan :style-to-add="getContractStatusStyle(product)" :value="product.contractStatus" />
      </FieldRow>
      <FieldRow label="Offre d'assurance">
        <FieldSpan :style-to-add="getEnabledFieldStyle(product)" :value="product.enabled ? 'Publiée' : 'Non publiée'" />
      </FieldRow>
    </div>
  </div>
</template>

<script>
import { FieldSpan, FieldRow } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  components: {
    FieldRow,
    FieldSpan,
  },
  props: ["product"],
  computed: {
    ...mapGetters("products", ["getContractStatusStyle", "getEnabledFieldStyle"]),
  },
};
</script>
